<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_STAFF'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.First Name' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.firstname }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Last Name' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.lastname }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Office' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.officeName }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Is Loan Officer' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.isLoanOfficer === true | yesNo }}
        </div>

        @if (employeeData.mobileNo) {
          <div class="flex-50 mat-body-strong">
            {{ 'labels.inputs.Mobile Number for SMS' | translate }}
          </div>
        }

        @if (employeeData.mobileNo) {
          <div class="flex-50">
            {{ employeeData.mobileNo }}
          </div>
        }

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Status' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.isActive === true ? 'Active' : 'Inactive' }}
        </div>

        <div class="flex-50 mat-body-strong">
          {{ 'labels.inputs.Joining Date' | translate }}
        </div>

        <div class="flex-50">
          {{ employeeData.joiningDate | dateFormat }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
